module.exports = __webpack_public_path__ + "img/official_account.204cd1b9.jpg";